// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__1upjI h3 {
  padding: 0rem 1rem; }

.styles_container__1upjI .styles_textarea__ZIa6e {
  resize: none;
  width: -webkit-fill-available; }

.styles_container__1upjI button {
  margin: 0.5rem 1rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/sub-modules/ui-kit/components/TextAreaModal/styles.module.scss"],"names":[],"mappings":"AAAA;EAEI,kBAAkB,EAAA;;AAFtB;EAKI,YAAY;EACZ,6BAA6B,EAAA;;AANjC;EASI,mBAAmB,EAAA","sourcesContent":[".container {\n  h3 {\n    padding: 0rem 1rem;\n  }\n  .textarea {\n    resize: none;\n    width: -webkit-fill-available;\n  }\n  button {\n    margin: 0.5rem 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__1upjI`,
	"textarea": `styles_textarea__ZIa6e`
};
export default ___CSS_LOADER_EXPORT___;
